import { unsafeHTML } from '@resn/gozer-core';

export default (icon, className = '', ref = '') =>
    unsafeHTML(`<svg data-ui="${ref || icon}" class="${className}"><use xlink:href="#${icon}"></use></svg>
`);
